const REWARDS = [
    {
        id: 4,
        name: "盛趣点券×5000",
        icon: "https://static.web.sdo.com/xyx/pic/act/2026/0902_Join/rewards/4.png",
        type: 1
    },
    {
        id: 5,
        name: "盛趣点券×2000",
        icon: "https://static.web.sdo.com/xyx/pic/act/2026/0902_Join/rewards/5.png"
    },
    {
        id: 6,
        name: "盛趣点券×500",
        icon: "https://static.web.sdo.com/xyx/pic/act/2026/0902_Join/rewards/6.png"
    },
    {
        id: 1,
        name: "十二生肖酒具礼盒",
        icon: "https://static.web.sdo.com/xyx/pic/act/2026/0902_Join/rewards/1.png"
    },
    {
        id: 2,
        name: "战法弓兵器套装",
        icon: "https://static.web.sdo.com/xyx/pic/act/2026/0902_Join/rewards/2.png"
    },
    {
        id: 3,
        name: "定制抱枕",
        icon: "https://static.web.sdo.com/xyx/pic/act/2026/0902_Join/rewards/3.png"
    },
    {
        id: 7,
        name: "游戏道具：宠物蛋（白泽）",
        icon: "https://static.web.sdo.com/xyx/pic/act/2026/0902_Join/rewards/7.png"
    },
    {
        id: 8,
        name: "游戏道具：金龙舍利子",
        icon: "https://static.web.sdo.com/xyx/pic/act/2026/0902_Join/rewards/8.png"
    },
    {
        id: 9,
        name: "游戏道具：魔神精魄",
        icon: "https://static.web.sdo.com/xyx/pic/act/2026/0902_Join/rewards/9.png"
    }
];

export default REWARDS;
